import { ApolloLink, HttpLink } from '@apollo/client';
import { ErrorLink } from '@apollo/client/link/error';
import { useSetAtom } from 'jotai';
import { useMemo } from 'react';

import { client as clientBase } from 'configurations/apolloClient';
import {
  BACKEND_GRAPHQL_URL,
  ERRORS_SERVER_STATUS,
  ERROR_SERVER_TYPES,
} from 'constants/app';
import { errorState } from 'states/app';

const httpLink = new HttpLink({
  uri: BACKEND_GRAPHQL_URL,
});

const useApolloClient = () => {
  const setError = useSetAtom(errorState);

  const client = useMemo(() => {
    const errorLink = new ErrorLink(({ error }) => {
      if (
        ERRORS_SERVER_STATUS.find((errorId) => errorId === error.statusCode)
      ) {
        setError(ERROR_SERVER_TYPES.SERVER_ERROR);
      }
    });

    const additiveLink = ApolloLink.from([errorLink, httpLink]);

    clientBase.setLink(additiveLink);
    return clientBase;
  }, [setError]);

  return client;
};

export default useApolloClient;
